import { loginDirectus } from './login';
import { getDirectusToken } from '../../../utils/localStorage';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;
const DIRECTUS_REIMBURSEMENTS_COLLECTION =
  process.env.REACT_APP_DIRECTUS_REIMBURSEMENTS_COLLECTION;

export async function getReimbursements({ signal, user, password } = {}) {
  if (!DIRECTUS_URL) {
    console.error('[Directus] REACT_APP_DIRECTUS_URL fehlt.');
    throw new Error('REACT_APP_DIRECTUS_URL fehlt.');
  }
  if (!DIRECTUS_REIMBURSEMENTS_COLLECTION) {
    console.error('[Directus] REACT_APP_DIRECTUS_REIMBURSEMENTS_COLLECTION fehlt.');
    throw new Error('REACT_APP_DIRECTUS_REIMBURSEMENTS_COLLECTION fehlt.');
  }

  let token = getDirectusToken();
  if (!token) {
    console.warn('[Directus] Kein Token gefunden. Login wird ausgeführt.');
    token = await loginDirectus(
      user, password
    );
  }
  const params = new URLSearchParams({
    sort: '-date_created,-id',
    fields: [
      'id',
      'status',
      'billing_period',
      'date_created',
      'date_approved',
      'date_credited',
      'amount_kwh',
      'amount_currency',
      'currency',
      'notes',
      'credited_notes',
      'driver',
      'vehicle',
      'org_unit',
      'user_approved',
      'document'
    ].join(',')
  });
  const url = `${DIRECTUS_URL}/items/${DIRECTUS_REIMBURSEMENTS_COLLECTION}?${params.toString()}`;
  console.info('[Directus] GET Reimbursement start', {
    url,
    hasToken: Boolean(token)
  });
  let response = await fetch(
    url,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      signal
    }
  );

  if (response.status === 401) {
    console.warn('[Directus] Token abgelaufen/ungültig. Re-Login.');
    token = await loginDirectus(
      user, password
    );
    response = await fetch(
      url,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        signal
      }
    );
  }

  if (!response.ok) {
    let responseText = '';
    try {
      responseText = await response.text();
    } catch (error) {
      responseText = `[body read failed: ${error.message}]`;
    }
    console.error('[Directus] GET Reimbursement failed', {
      status: response.status,
      statusText: response.statusText,
      responseText
    });
    throw new Error(`Directus-Fehler: ${response.status}`);
  }

  const payload = await response.json();
  console.info('[Directus] GET Reimbursement ok', {
    count: Array.isArray(payload?.data) ? payload.data.length : 0
  });
  return Array.isArray(payload?.data) ? payload.data : [];
}
